import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { CHAT_MODE_HIDDEN } from '../lib/workspaceMode';

/**
 * ChatRedirect — backward-compat for the chat route rename.
 *
 * A conversation now lives at /chat/:id. Old links (bookmarks, open tabs,
 * anything persisted) hit the legacy /dashboard/:id or /chats/:id and bounce
 * here. <Navigate> can't interpolate :id (its `to` is a literal path), so we
 * read the param and build the new path ourselves.
 *
 *   /dashboard/:id ─┐
 *   /chats/:id      ─┴▶ <ChatRedirect> ──▶ /chat/:id   (replace, no history entry)
 *   (no id)         ───────────────────▶ /chat         (chat home)
 *
 * With Chat hidden (CHAT_MODE_HIDDEN) every chat path, /chat itself
 * included, lands on /apps and keeps its query (?connectors=… toasts).
 */
const ChatRedirect: React.FC = () => {
  const { id } = useParams();
  const { search } = useLocation();
  if (CHAT_MODE_HIDDEN) return <Navigate to={`/apps${search}`} replace />;
  return <Navigate to={id ? `/chat/${id}` : '/chat'} replace />;
};

export default ChatRedirect;
